import {
    CheckLineIcon,
    HandHelpingIcon,
    NotepadTextIcon,
    PiggyBankIcon,
    WalletIcon,
} from 'lucide-react-native';
import React, { useState } from 'react';
import { Separator, XStack, YStack } from 'tamagui';

import Switch from '../../components/inputs/Switch';
import { SegmentedControl } from '../../components/segmented-controls/SegmentedControl';
import {
    BodyLargeEmphasized,
    BodySmallRegular,
    H5Emphasized,
    LabelEmphasized,
} from '../../components/text/Typography';
import { isNonMobileWeb } from '../../constants';

export const SegmentedControlsAndSwitches = () => {
    const [switch1Checked, setSwitch1Checked] = useState(true);
    const [switch2Checked, setSwitch2Checked] = useState(false);

    const [selectedTwo, setSelectedTwo] = useState<'option1' | 'option2'>(
        'option1',
    );
    const [selectedThree, setSelectedThree] = useState<
        'option1' | 'option2' | 'option3'
    >('option1');
    const [selectedWithDot, setSelectedWithDot] = useState<
        'primary' | 'partner'
    >('primary');
    const [selectedWithIcon, setSelectedWithIcon] = useState<
        'spending' | 'savings'
    >('spending');
    const [selectedSmallTwo, setSelectedSmallTwo] = useState<
        'option1' | 'option2'
    >('option1');
    const [selectedSmallThree, setSelectedSmallThree] = useState<
        'option1' | 'option2' | 'option3'
    >('option1');
    const [selectedLabel, setSelectedLabel] = useState<
        'option1' | 'option2' | 'option3'
    >('option1');

    const [isLarge, setIsLarge] = useState(true);
    const [isLarge2, setIsLarge2] = useState(true);
    const [isFullWidth, setIsFullWidth] = useState(true);
    const [isFullWidth2, setIsFullWidth2] = useState(true);
    const [showIcons, setShowIcons] = useState(false);

    return (
        <YStack gap={48} maxWidth={500}>
            <YStack gap={16}>
                <H5Emphasized>Switch</H5Emphasized>
                <BodySmallRegular>
                    A native switch component for on/off toggles. Perfect for
                    settings, preferences, and binary state controls. Supports
                    enabled and disabled states with platform-specific styling.
                </BodySmallRegular>
                <YStack gap={16} maxWidth={200}>
                    <XStack
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                    >
                        <BodySmallRegular>
                            &quot;On&quot; state
                        </BodySmallRegular>
                        <Switch
                            isChecked={switch1Checked}
                            onCheckedChange={setSwitch1Checked}
                        />
                    </XStack>
                    <XStack
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                    >
                        <BodySmallRegular>
                            &quot;Off&quot; state
                        </BodySmallRegular>
                        <Switch
                            isChecked={switch2Checked}
                            onCheckedChange={setSwitch2Checked}
                        />
                    </XStack>
                    <XStack
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                    >
                        <BodySmallRegular>
                            Disabled - &quot;On&quot; state
                        </BodySmallRegular>
                        <Switch
                            isChecked={true}
                            onCheckedChange={() => {}}
                            disabled={true}
                        />
                    </XStack>
                    <XStack
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                    >
                        <BodySmallRegular>
                            Disabled - &quot;Off&quot; state
                        </BodySmallRegular>
                        <Switch
                            isChecked={false}
                            onCheckedChange={() => {}}
                            disabled={true}
                        />
                    </XStack>
                </YStack>
            </YStack>

            <Separator />

            <YStack gap={6}>
                <H5Emphasized marginBottom={16}>SegmentedControl</H5Emphasized>
                <BodyLargeEmphasized>Size: small</BodyLargeEmphasized>
                <BodySmallRegular>Width: auto</BodySmallRegular>
                <YStack gap={6} alignItems="center">
                    <SegmentedControl
                        selected={selectedSmallTwo}
                        defaultValue={selectedSmallTwo}
                        onValueChange={setSelectedSmallTwo}
                        options={[
                            { label: 'Statements', value: 'option1' },
                            { label: 'Taxes', value: 'option2' },
                        ]}
                        size="small"
                        width="auto"
                    />
                    <SegmentedControl
                        selected={selectedSmallThree}
                        defaultValue={selectedSmallThree}
                        onValueChange={setSelectedSmallThree}
                        options={[
                            { label: 'Statements', value: 'option1' },
                            { label: 'Trades', value: 'option2' },
                            { label: 'Taxes', value: 'option3' },
                        ]}
                        size="small"
                        width="auto"
                    />
                </YStack>
                <BodySmallRegular>Width: full</BodySmallRegular>
                <SegmentedControl
                    selected={selectedSmallTwo}
                    defaultValue={selectedSmallTwo}
                    onValueChange={setSelectedSmallTwo}
                    options={[
                        { label: 'Statements', value: 'option1' },
                        { label: 'Taxes', value: 'option2' },
                    ]}
                    size="small"
                />
                <SegmentedControl
                    selected={selectedSmallThree}
                    defaultValue={selectedSmallThree}
                    onValueChange={setSelectedSmallThree}
                    options={[
                        { label: 'Statements', value: 'option1' },
                        { label: 'Trades', value: 'option2' },
                        { label: 'Taxes', value: 'option3' },
                    ]}
                    size="small"
                />
            </YStack>
            <YStack gap={6}>
                <BodyLargeEmphasized>Size: large</BodyLargeEmphasized>
                <BodySmallRegular>Width: auto</BodySmallRegular>
                <YStack gap={6} alignItems="center">
                    <SegmentedControl
                        selected={selectedTwo}
                        defaultValue={selectedTwo}
                        onValueChange={setSelectedTwo}
                        options={[
                            { label: 'Individual', value: 'option1' },
                            { label: 'Joint', value: 'option2' },
                        ]}
                        size="large"
                        width="auto"
                    />
                    <SegmentedControl
                        selected={selectedThree}
                        defaultValue={selectedThree}
                        onValueChange={setSelectedThree}
                        options={[
                            { label: 'All', value: 'option1' },
                            { label: 'Spending', value: 'option2' },
                            { label: 'Savings', value: 'option3' },
                        ]}
                        size="large"
                        width="auto"
                    />
                </YStack>
                <BodySmallRegular>Width: full</BodySmallRegular>
                <SegmentedControl
                    selected={selectedTwo}
                    defaultValue={selectedTwo}
                    onValueChange={setSelectedTwo}
                    options={[
                        { label: 'Individual', value: 'option1' },
                        { label: 'Joint', value: 'option2' },
                    ]}
                    size="large"
                />
                <SegmentedControl
                    selected={selectedThree}
                    defaultValue={selectedThree}
                    onValueChange={setSelectedThree}
                    options={[
                        { label: 'All', value: 'option1' },
                        { label: 'Spending', value: 'option2' },
                        { label: 'Savings', value: 'option3' },
                    ]}
                    size="large"
                />
            </YStack>
            <YStack gap={12}>
                <BodyLargeEmphasized>Option accessories</BodyLargeEmphasized>
                <XStack gap={32}>
                    <XStack alignItems="center" gap={4}>
                        <LabelEmphasized>Large</LabelEmphasized>
                        <Switch
                            isChecked={isLarge}
                            onCheckedChange={setIsLarge}
                        />
                    </XStack>
                    <XStack alignItems="center" gap={4}>
                        <LabelEmphasized>Full width</LabelEmphasized>
                        <Switch
                            isChecked={isFullWidth}
                            onCheckedChange={setIsFullWidth}
                        />
                    </XStack>
                </XStack>
                <YStack gap={6}>
                    <BodySmallRegular>icon</BodySmallRegular>
                    <YStack gap={6} alignItems="center">
                        <SegmentedControl
                            selected={selectedWithIcon}
                            defaultValue={selectedWithIcon}
                            onValueChange={setSelectedWithIcon}
                            options={[
                                {
                                    value: 'spending',
                                    label: 'Spending',
                                    icon: WalletIcon,
                                },
                                {
                                    value: 'savings',
                                    label: 'Savings',
                                    icon: PiggyBankIcon,
                                },
                            ]}
                            size={isLarge ? 'large' : 'small'}
                            width={isFullWidth ? 'full' : 'auto'}
                        />
                    </YStack>
                </YStack>
                <YStack gap={6}>
                    <BodySmallRegular>
                        showDot: Use the dot indicator to show
                        attention-required states.
                    </BodySmallRegular>
                    <YStack gap={6} alignItems="center">
                        <SegmentedControl
                            selected={selectedWithDot}
                            defaultValue={selectedWithDot}
                            onValueChange={setSelectedWithDot}
                            options={[
                                {
                                    value: 'primary',
                                    label: 'Primary',
                                    showDot: true,
                                },
                                {
                                    value: 'partner',
                                    label: 'Partner',
                                    showDot: true,
                                },
                            ]}
                            size={isLarge ? 'large' : 'small'}
                            width={isFullWidth ? 'full' : 'auto'}
                        />
                    </YStack>
                </YStack>
            </YStack>
            <YStack gap={12}>
                <BodyLargeEmphasized>
                    Label width and wrapping
                </BodyLargeEmphasized>
                <XStack gap={32}>
                    <XStack alignItems="center" gap={4}>
                        <LabelEmphasized>Large</LabelEmphasized>
                        <Switch
                            isChecked={isLarge2}
                            onCheckedChange={setIsLarge2}
                        />
                    </XStack>
                    <XStack alignItems="center" gap={4}>
                        <LabelEmphasized>Full width</LabelEmphasized>
                        <Switch
                            isChecked={isFullWidth2}
                            onCheckedChange={setIsFullWidth2}
                        />
                    </XStack>
                    <XStack alignItems="center" gap={4}>
                        <LabelEmphasized>Icons</LabelEmphasized>
                        <Switch
                            isChecked={showIcons}
                            onCheckedChange={setShowIcons}
                        />
                    </XStack>
                </XStack>
                <BodySmallRegular>
                    Long label names should wrap gracefully
                </BodySmallRegular>
                <YStack gap={6} alignItems="center">
                    <SegmentedControl
                        selected={selectedLabel}
                        defaultValue={selectedLabel}
                        onValueChange={setSelectedLabel}
                        options={[
                            {
                                label: isLarge2 ? 'Monthly' : 'Statements',
                                value: 'option1',
                                icon: showIcons ? NotepadTextIcon : undefined,
                            },
                            {
                                label: isNonMobileWeb
                                    ? 'Trade confirmation documents'
                                    : isLarge2
                                      ? 'Trade confirms'
                                      : 'Trade confirmations',
                                value: 'option2',
                                icon: showIcons ? HandHelpingIcon : undefined,
                            },
                            {
                                label: isNonMobileWeb
                                    ? 'Tax return documents'
                                    : isLarge2
                                      ? 'Tax returns'
                                      : 'Tax return documents',
                                value: 'option3',
                                icon: showIcons ? CheckLineIcon : undefined,
                            },
                        ]}
                        size={isLarge2 ? 'large' : 'small'}
                        width={isFullWidth2 ? 'full' : 'auto'}
                    />
                </YStack>
                <BodySmallRegular>
                    The &apos;flexBasis&apos; option prop enables increasing
                    width of specific options to avoid wrapping
                </BodySmallRegular>
                <YStack gap={6} alignItems="center">
                    <SegmentedControl
                        selected={selectedLabel}
                        defaultValue={selectedLabel}
                        onValueChange={setSelectedLabel}
                        options={[
                            {
                                label: isNonMobileWeb
                                    ? 'Statements'
                                    : 'Statement docs',
                                value: 'option1',
                                flexBasis: isNonMobileWeb ? 0 : 68,
                                icon: showIcons ? NotepadTextIcon : undefined,
                            },
                            {
                                label: isNonMobileWeb
                                    ? 'Trade confirmation documents'
                                    : 'Trade docs',
                                value: 'option2',
                                flexBasis: isNonMobileWeb ? 110 : 0,
                                icon: showIcons ? HandHelpingIcon : undefined,
                            },
                            {
                                label: 'Taxes',
                                value: 'option3',
                                icon: showIcons ? CheckLineIcon : undefined,
                            },
                        ]}
                        size={isLarge2 ? 'large' : 'small'}
                        width={isFullWidth2 ? 'full' : 'auto'}
                    />
                </YStack>
            </YStack>
        </YStack>
    );
};
